import { render, staticRenderFns } from "./PrivacyPolicyCN.vue?vue&type=template&id=3e622218&scoped=true&"
import script from "./PrivacyPolicyCN.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyCN.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicyCN.vue?vue&type=style&index=0&id=3e622218&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e622218",
  null
  
)

export default component.exports